import { IToastContrast, IToastSize, IToastType } from "../../typings";
import { store } from "../store";
import { IUserActionTypes } from "../store/actions";
import { MAINTENANCE_URL } from ".";
const getNiceTime = (milliseconds) => {
    const minutes = Math.ceil(milliseconds / (60 * 1000));
    if (minutes > 60) {
        const hours = Math.floor(minutes / 60);
        if (hours === 1) {
            return hours + " hour " + Math.ceil(minutes - hours * 60) + " minutes";
        }
        else {
            return hours + " hours " + Math.ceil(minutes - hours * 60) + " minutes";
        }
    }
    return minutes + " minutes";
};
export const performMaintenanceCheck = async () => {
    let res;
    try {
        res = await fetch(MAINTENANCE_URL);
    }
    catch (err) {
        return console.warn('Unable to fetch maintenance info:', err);
    }
    const data = await res.json();
    if (data['Status'] !== 'planned')
        return;
    const date = new Date(data['Time']);
    const localeString = date.toLocaleString();
    const now = new Date();
    const niceTimeUntil = getNiceTime(date.getTime() - now.getTime());
    const niceDurationTime = getNiceTime(data['Duration']);
    store.dispatch({
        type: IUserActionTypes.ADD_TOAST,
        payload: {
            type: IToastType.info,
            contrast: IToastContrast.high,
            size: IToastSize.default,
            message: `MAINTENANCE_${localeString}_${niceTimeUntil}_${niceDurationTime}`,
            closable: true
        }
    });
};
